export const consts = {
    FONT_SIZE: 12,
}